import css from 'styled-jsx/css';

export default css`
  .moduloPasos {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    text-align: center;
    .containerSteps {
      display: flex;
      gap: 6rem;
    }
    :global(.iconLabel_label) {
      padding-top: 20px;
    }
    :global(.customButton) {
      background: #ffffff;
      color: #019df4;
      font-family: 'Regular';
      width: 259px;
    }
  }
  @media screen and (max-width: 768px) {
    .moduloPasos {
      .containerSteps {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
      }
      :global(.customButton) {
        width: 100%;
      }
    }
  }
`;
